import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CAMPAIGN_WITH_DOMAINS_QUERY } from './campaignWithDomains.query';
import { CampaignWithDomainsQuery } from './__generated__/CampaignWithDomainsQuery';

export const useCampaignWithDomainsQuery = () => {
  return useLazyQuery<CampaignWithDomainsQuery>(CAMPAIGN_WITH_DOMAINS_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
